import { CourseFormFieldApi } from "api";
import { CourseTrancheApi } from "api/types";
import { baseUserProps, notesProps, paymentProps, registrationProps } from "../studentColumns";

export interface FieldGroupField {
  key: string;
  label: string;
}

export interface FieldGroup {
  name: string;
  dot: string;
  fields: FieldGroupField[];
}

export const buildFieldGroups = (fields: CourseFormFieldApi[], tranches: CourseTrancheApi[]): FieldGroup[] => [
  {
    name: "Podstawowe dane",
    dot: "#3b82f6",
    fields: baseUserProps.map((f) => ({ key: f.value, label: f.label })),
  },
  {
    name: "Płatności i rozliczenia",
    dot: "#10b981",
    fields: [
      ...paymentProps.map((f) => ({ key: f.value, label: f.label })),
      ...tranches.map((t) => ({ key: `tranche_${t.id}`, label: t.name })),
    ],
  },
  {
    name: "Formularz rejestracyjny",
    dot: "#8b5cf6",
    fields: [
      ...registrationProps.map((f) => ({ key: f.value, label: f.label })),
      ...fields.map((f) => ({ key: f.id.toString(), label: f.name })),
    ],
  },
  {
    name: "Notatki użytkownika",
    dot: "#64748b",
    fields: notesProps.map((f) => ({ key: f.value, label: f.label })),
  },
];

const DEFAULT_ON = ["lp", "fullName", "fullyPaid", "registrationDate"];

export const getDefaultColumnOrder = (groups: FieldGroup[], tranches: CourseTrancheApi[]): string[] => {
  const defaultOn = new Set([...DEFAULT_ON, ...tranches.map((t) => `tranche_${t.id}`)]);
  return groups
    .flatMap((g) => g.fields)
    .filter((f) => defaultOn.has(f.key))
    .map((f) => f.key);
};
